import React from 'react';
import { PhoneMockup } from '@/components/PhoneMockup';
const screens = [
  { src: '/screenshots/screen2.png', label: 'Split Expenses', sub: 'Divide travel costs instantly' },
  { src: '/screenshots/screen3.png', label: 'Expense Tracking', sub: 'Track totals by trip or person' },
  { src: '/screenshots/screen4.png', label: 'Live Rates', sub: 'Browse live rates and market status' },
  { src: '/screenshots/screen6.png', label: 'All Currencies', sub: 'A huge list of supported currencies' },
  { src: '/screenshots/screen9.png', label: 'Themes', sub: 'Themes, colors, and custom styling' },
];
export function GallerySection() {
  return (
    <section className="bg-[#FEF7FF] dark:bg-m3-dark-surface pt-24 pb-0">
      <div className="max-w-[1200px] mx-auto px-8 pb-14">
        <div className="text-xs font-bold tracking-[0.12em] uppercase text-[#6750A4] mb-3">The app</div>
        <h2 className="text-[clamp(32px,3.5vw,48px)] font-extrabold tracking-[-0.03em] leading-[1.1] text-[#1D1B20] dark:text-white mb-4">
          Elegance in every pixel.
        </h2>
        <p className="text-lg text-[#79747E] leading-relaxed max-w-[500px]">
          Designed with Material 3 principles for a cohesive, intuitive experience across all your Android devices.
        </p>
      </div>
      <div
        className="flex overflow-x-auto gap-6 pt-8 pb-16 no-scrollbar"
        style={{
          paddingLeft: 'max(32px, calc((100vw - 1200px)/2 + 32px))',
          scrollSnapType: 'x mandatory',
        }}
      >
        {screens.map((s, i) => (
          <div key={i} className="flex-none flex flex-col items-center gap-5 group" style={{ scrollSnapAlign: 'start' }}>
            <div className="w-[170px] transition-transform duration-500 group-hover:-translate-y-3">
              <PhoneMockup imageUrl={s.src} alt={`AwayFX ${s.label}: ${s.sub}`} />
            </div>
            <div className="text-center">
              <h4 className="text-base font-bold text-[#1D1B20] dark:text-white tracking-[-0.015em]">{s.label}</h4>
              <p className="text-sm text-[#79747E] mt-0.5">{s.sub}</p>
            </div>
          </div>
        ))}
        <div className="flex-none w-8" />
      </div>
    </section>
  );
}
